window.otplib.authenticator.options = {
  step: 30,
};

export default {
  generate: function(secret) {
    return window.otplib.authenticator.generate(secret.replace(new RegExp(' ', 'g'), ''))
  },
}